import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Tag, Copy, Calendar, Frown } from "lucide-react";
import api from "./axiosConfig";

export default function MesCoupons() {
  const navigate = useNavigate();
  const phone = localStorage.getItem("customerPhone");
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (phone) {
      api.get(`/users/client/${phone}/coupons`)
        .then((res) => {
          setCoupons(res.data.coupons || []);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [phone]);

  const copyToClipboard = (code) => {
    navigator.clipboard.writeText(code);
    alert(`Code ${code} copié !`);
  };

  return (
    <div className="min-h-screen px-4 pt-6 pb-20 font-sans bg-gray-50">
      {/* HEADER */}
      <div className="flex items-center gap-4 mb-6">
        <button 
          onClick={() => navigate(-1)}
          className="p-2 transition bg-white rounded-full shadow-sm hover:bg-gray-100"
        >
          <ChevronLeft className="w-6 h-6 text-gray-700" />
        </button>
        <h1 className="text-xl font-bold text-gray-800">Mes Coupons</h1>
      </div>

      {loading ? (
        <div className="flex justify-center mt-10 text-gray-400">Chargement...</div>
      ) : coupons.length === 0 ? (
        <div className="flex flex-col items-center justify-center mt-20 text-center opacity-70">
            <div className="p-6 mb-4 bg-gray-200 rounded-full">
                <Frown size={48} className="text-gray-500"/>
            </div>
            <h3 className="text-lg font-bold text-gray-600">Aucun coupon disponible</h3>
            <p className="max-w-xs mt-2 text-sm text-gray-500">Vous n'avez pas de réduction active pour le moment. Revenez plus tard !</p>
        </div>
      ) : (
        <div className="space-y-4">
          {coupons.map((coupon) => (
            <div key={coupon._id} className="relative flex flex-col overflow-hidden bg-white border border-gray-100 shadow-sm rounded-2xl">
              
              {/* BANDEAU GAUCHE DECORATIF */}
              <div className="absolute top-0 bottom-0 left-0 w-2 bg-[#f34141]"></div>

              <div className="flex items-start justify-between p-5 pl-7">
                <div>
                    <div className="flex items-center gap-2 mb-1">
                         <span className="text-xs font-bold text-white bg-orange-400 px-2 py-0.5 rounded-md">
                            {coupon.discountType === "PERCENT" ? `-${coupon.discountValue}%` : `-${coupon.discountValue} MRU`}
                         </span>
                         {coupon.minOrderAmount > 0 && (
                             <span className="text-[10px] text-gray-400 font-medium">Min. {coupon.minOrderAmount} MRU</span>
                         )}
                    </div>
                    
                    <h3 className="text-lg font-extrabold tracking-wide text-gray-800">{coupon.code}</h3>
                    <p className="mt-1 text-sm text-gray-500">{coupon.description || "Réduction spéciale"}</p>
                </div>
                
                <button 
                    onClick={() => copyToClipboard(coupon.code)}
                    className="p-2 bg-gray-50 rounded-lg text-gray-600 hover:text-[#f34141] transition-colors"
                >
                    <Copy size={20} />
                </button>
              </div>

              {/* FOOTER DU COUPON */}
              <div className="flex items-center gap-2 px-5 py-3 text-xs text-gray-500 border-t border-gray-100 bg-gray-50 pl-7">
                <Calendar size={14} />
                <span>Expire le : {new Date(coupon.expiresAt).toLocaleDateString("fr-FR")}</span>
              </div>

              {/* CERCLES DECORATIFS (Effet Ticket) */}
              <div className="absolute w-6 h-6 -translate-y-1/2 rounded-full -left-3 top-1/2 bg-gray-50"></div>
              <div className="absolute w-6 h-6 -translate-y-1/2 rounded-full -right-3 top-1/2 bg-gray-50"></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}